import { supabase } from "./supabaseClient";

export const profileService = {
  // Busca o perfil de um usuário pelo ID
  getProfile: async (userId) => {
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", userId)
      .single();

    if (error && error.code !== "PGRST116") {
      // PGRST116 means no rows found
      throw new Error(error.message);
    }
    return data;
  },

  // Cria um novo perfil para um usuário
  createProfile: async (userId, initialData = {}) => {
    const { data, error } = await supabase
      .from("profiles")
      .insert({ id: userId, ...initialData })
      .single();

    if (error) {
      throw new Error(error.message);
    }
    return data;
  },

  // Atualiza um perfil existente
  updateProfile: async (userId, updates) => {
    const { data, error } = await supabase
      .from("profiles")
      .update(updates)
      .eq("id", userId)
      .single();

    if (error) {
      throw new Error(error.message);
    }
    return data;
  },

  // Faz upload de uma imagem de avatar para o Supabase Storage
  uploadAvatar: async (userId, file) => {
    const fileExt = file.name.split(".").pop();
    const fileName = `${userId}.${fileExt}`;
    const filePath = `${userId}/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from("avatars") // Certifique-se de que este bucket existe no Supabase
      .upload(filePath, file, {
        cacheControl: "3600",
        upsert: true, // Sobrescreve se o arquivo já existir
      });

    if (uploadError) {
      throw new Error(uploadError.message);
    }

    // Obtém a URL pública do arquivo
    const { data: publicUrlData } = supabase.storage
      .from("avatars")
      .getPublicUrl(filePath);

    if (!publicUrlData || !publicUrlData.publicUrl) {
      throw new Error("Não foi possível obter a URL pública do avatar.");
    }

    // Atualiza o avatar_url no perfil do usuário
    const { error: profileError } = await supabase
      .from("profiles")
      .update({ avatar_url: publicUrlData.publicUrl })
      .eq("id", userId)
      .single();

    if (profileError) {
      throw new Error(profileError.message);
    }

    return publicUrlData.publicUrl;
  },
};
